
export { defaultApiBasicX } from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/apis/new-apis/default-api.ts"